import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load all page components
const Home = lazy(() => import('./pages/home'));
const Vault = lazy(() => import('./pages/vault'));

/**
 * Application routes component
 * Sync happens automatically via middleware when vault data changes
 */
export const AdviserRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/vaults/:shareId" element={<Vault />} />
    </Routes>
  );
};